import { render, staticRenderFns } from "./homepageVideo.vue?vue&type=template&id=182aa650&scoped=true&"
import script from "./homepageVideo.vue?vue&type=script&lang=js&"
export * from "./homepageVideo.vue?vue&type=script&lang=js&"
import style0 from "./homepageVideo.vue?vue&type=style&index=0&id=182aa650&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182aa650",
  null
  
)

export default component.exports